import {
  useV2CreateLobApprovalUserMutation,
  useV2UpdateLobApprovalUserMutation,
  useV2DeleteLobApprovalUserMutation,
} from "@generated";

export const useLobApprovalUserMutations = () => {
  const [create, createState] = useV2CreateLobApprovalUserMutation();
  const [update, updateState] = useV2UpdateLobApprovalUserMutation();
  const [destroy, destroyState] = useV2DeleteLobApprovalUserMutation();

  return {
    create: (lobApprovalId: string, userId: string, requiredApprover = false) =>
      create({
        body: {
          data: {
            type: "lob-approval-users",
            attributes: {
              "required-approver": requiredApprover,
              "user-id": Number(userId),
            },
            relationships: {
              "lob-approval": {
                data: { type: "lob-approvals", id: Number(lobApprovalId) },
              },
            },
          },
        },
      }).unwrap(),

    update: (id: string, requiredApprover: boolean) =>
      update({
        id: Number(id),
        body: {
          data: {
            type: "lob-approval-users",
            id: Number(id),
            attributes: { "required-approver": requiredApprover },
          },
        },
      }).unwrap(),

    destroy: (id: string) => destroy({ id: Number(id) }).unwrap(),

    states: { createState, updateState, destroyState },
  };
};
